import { useEffect, useState } from "react";
import { API_BASE, resolveMediaUrl } from "../helpers/api";

const resolveGalleryImage = (path) => {
  if (!path) return "";
  // Existing bundled images are retained by the data migration. New Admin
  // uploads use Django's /api/media/gallery_images/ endpoint.
  if (path.startsWith("/images/")) return path;
  return resolveMediaUrl(path);
};

export default function useGalleryImages({ featured = false } = {}) {
  const [images, setImages] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    const controller = new AbortController();
    const query = featured ? "?featured=true" : "";

    async function loadImages() {
      try {
        setLoading(true);
        setError("");
        const response = await fetch(`${API_BASE}/gallery/${query}`, {
          signal: controller.signal,
        });
        if (!response.ok) throw new Error("Unable to load gallery images.");
        const payload = await response.json();
        const results = Array.isArray(payload) ? payload : payload?.results || [];
        setImages(
          results.map((item) => ({
            ...item,
            src: resolveGalleryImage(item.image),
            alt: item.alt_text || item.title,
          }))
        );
      } catch (err) {
        if (err.name !== "AbortError") {
          setError(err.message || "Unable to load gallery images.");
        }
      } finally {
        if (!controller.signal.aborted) setLoading(false);
      }
    }

    loadImages();
    return () => controller.abort();
  }, [featured]);

  return { images, loading, error };
}
